import { UserRole } from "../components/users/UserList"
import { AccountUsersConfiguration } from "../store/creditsAccount/CreditsAccountContext"

export const CanSeeCredits = (accountUsersConfig: AccountUsersConfiguration, currentUserRole: UserRole) => {
    return ((accountUsersConfig.DisplayCreditsToInvitedUsers && currentUserRole == UserRole.User)
    || (currentUserRole == UserRole.Admin))
}